// GlobalContext.js
import React, { createContext, useContext, useState } from 'react';

// Create Context
const GlobalContext = createContext();

// Create a Provider Component
export const GlobalProvider = ({ children }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [totalStars, setTotalStars] = useState(0);

  return (
    <GlobalContext.Provider
      value={{
        selectedUser,
        setSelectedUser,
        totalStars,
        setTotalStars,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

// Create a hook to use the Global Context
export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
